import { ProcessedEvent } from '../../types'
import { CSSProperties, useState } from 'react'
import styles from './SingleDayBackgroundEvent.module.css'
import { Popover, Stack, Typography } from '@mui/material'
import { useSchedulerPropsContext } from '../../context/schedulerContext.ts'

interface SingleDayBackgroundEventProps {
  events: ProcessedEvent[]
  height: number
  top: number
}

export function SingleDayBackgroundEvents(
  props: SingleDayBackgroundEventProps
) {
  const { events, height, top } = props
  const { onEventsSelected } = useSchedulerPropsContext()
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault()
    e.stopPropagation()
    if (onEventsSelected) {
      setAnchorEl(e.currentTarget)
      const eventsSelectedEvent = new CustomEvent(
        'eventsSelected',
        {
          detail: { events },
          bubbles: false,
          composed: false,
          cancelable: true,
        }
      )
      onEventsSelected(eventsSelectedEvent)
    }
  }

  const handleOpen = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const style: CSSProperties = {
    height,
    top,
  }

  const open = Boolean(anchorEl)

  return (
    <div
      className={styles.SingleDayBackgroundEvent}
      style={style}
    >
      <button
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        className={styles.SingleDayBackgroundEvent_placeholder}
        onClick={handleClick}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      ></button>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={3}
        sx={{ pointerEvents: 'none' }}
        classes={{
          paper: styles.SingleDayBackgroundEvent_popover,
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 0,
        }}
      >
        <Stack gap={1}>
          {events.map((event) => (
            <Typography key={event.uid} variant="body2">
              {event.summary}
            </Typography>
          ))}
        </Stack>
      </Popover>
    </div>
  )
}
